import { Obj } from '@/types/common';

export function compareObjects<T extends Obj, K extends T>(obj1: T, obj2: K, fields: (keyof T)[]) {
  return fields.some((key) => {
    if (typeof obj1[key] === 'object' || typeof obj2[key] === 'object') {
      return JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key]);
    }
    return obj1[key] !== obj2[key];
  });
}
